import { SortRule } from '@economic/taco';

import { useCurrentAgreement } from '@economic/react-app';
import { Entity } from '../../../types';
import { openWindow } from '../../../utilities/openWindow';

const getStringifiedSortRules = (sortRules: SortRule<any>[] | undefined, columnIndex: Record<string, number>) => {
    if (!sortRules || sortRules.length === 0 || !columnIndex) {
        return '';
    }

    return sortRules.map(({ accessor, desc }) => (desc ? '-' + columnIndex[accessor] : columnIndex[accessor])).join(',');
};

export const useExcelExporter = (
    formNumber: number,
    sortRules: SortRule<any>[] | undefined,
    columnIndex: Record<string, number>,
    filter: string,
    currency?: string,
    accessType?: number
) => {
    const agreement = useCurrentAgreement();

    const stringifiedSortRules = getStringifiedSortRules(sortRules, columnIndex);
    const isProductForm = formNumber === Entity.Product;
    const url = `/internal-api/xlsx?source=${encodeURIComponent(
        `generelt/dataedit_excel.asp?form=${formNumber}&ops=${agreement.setupId}&SortBy=${stringifiedSortRules}&Search=${filter}${
            isProductForm ? `&valuta=${currency}&barred=${accessType}` : ''
        }`
    )}&reportTypeExporter=default`;

    return { open: () => openWindow(url, undefined, process.env.ECONOMIC_INTERNALAPI_PATH) };
};
